module.exports = __webpack_public_path__ + "01f43047/img/print-icon.d8dbbca5.svg";